export default __webpack_public_path__ + "static/media/loader.c06a09a8.gif";